import { GrowthDashboardTopBarActions, WebsiteHealthReportView } from '@elva/ui';
import { useCallback } from 'react';
import { AsyncBoundary } from '@/components/feedback';
import { usePageTopBar } from '@/app/layouts/pageTopBar';
import { viewProps } from '@/data/viewProps';
import {
  useWebsiteHealth,
  useWebsiteHealthMutations,
} from '@/features/website-health/hooks/useWebsiteHealth';

export function WebsiteHealthPage() {
  usePageTopBar({
    actions: <GrowthDashboardTopBarActions />,
  });

  const { data, isPending, isError, error, refetch, isRefetching, isFetching } = useWebsiteHealth();
  const { exportPdf } = useWebsiteHealthMutations();

  const handleExport = useCallback(() => {
    exportPdf.mutate();
  }, [exportPdf]);

  return (
    <AsyncBoundary
      loading={isPending}
      error={data === undefined && isError ? error : undefined}
      onRetry={refetch}
      retrying={isRefetching}
    >
      <WebsiteHealthReportView
        {...viewProps({
          items: data?.items ?? [],
          summary: data?.summary,
          loading: isFetching || exportPdf.isPending,
          onExport: handleExport,
        })}
      />
    </AsyncBoundary>
  );
}
